const routes = [
  {
    path: "/dex",
    name: "dex.index",
    component: () =>
      import(/* webpackChunkName: "dex" */ "../views/dex/Index.vue"),
    meta: {
      type: "dex",
      title: "",
      showBackBtn: false
    }
  },
  {
    path: "/dex/dashboard",
    component: () =>
      import(/* webpackChunkName: "dex" */ "../views/dex/Dashboard.vue"),
    meta: {
      type: "dex",
      title: "",
      showBackBtn: false
    },
    children: [
      {
        path: "dex/enterEmail",
        name: "dex.enterEmail",
        component: () =>
          import(/* webpackChunkName: "dex" */ "../views/dex/EnterEmail.vue"),
        meta: {
          type: "dex",
          title: "",
          showBackBtn: false
        }
      },
      {
        path: "dex/verifyEmail",
        name: "dex.verifyEmail",
        component: () =>
          import(/* webpackChunkName: "dex" */ "../views/dex/VerifyEmail.vue"),
        meta: {
          type: "dex",
          title: "",
          showBackBtn: true
        }
      },
      {
        path: "dex/Pending",
        name: "dex.pending",
        component: () =>
          import(/* webpackChunkName: "dex" */ "../views/dex/Pending.vue"),
        meta: {
          type: "dex",
          title: "",
          showBackBtn: true
        }
      }
    ]
  },
  {
    path: "dex/buy/confirm",
    name: "dex.buy.confirm",
    component: () =>
      import(/* webpackChunkName: "dex" */ "../views/dex/BuyConfirm.vue"),
    meta: {
      type: "dex",
      title: "",
      showBackBtn: false
    }
  }
];

export default routes;
